import { APIClientError } from './api-client-error';

export class TimeoutError extends APIClientError {
  public constructor(timeout: number) {
    super(`Request timed out after ${timeout}ms`);
    this.name = 'TimeoutError';
  }
}
